import { Fragment, ReactNode } from 'react';
import FeatureBlockWrapper, {
  IconWrapper,
  ContentWrapper,
  ButtonWrapper,
} from './featureBlock.style';

export type IconPosition = 'top' | 'left' | 'right';

export interface FeatureBlockProps {
  className?: string;
  id?: string;
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  button?: ReactNode;
  iconPosition?: IconPosition;
  listItems?: ReactNode;
  additionalContent?: ReactNode;
  wrapperStyle?: Record<string, unknown>;
  iconStyle?: Record<string, unknown>;
  contentStyle?: Record<string, unknown>;
  btnWrapperStyle?: Record<string, unknown>;
}

const FeatureBlock = ({
  className,
  icon,
  title,
  button,
  description,
  iconPosition = 'top',
  listItems,
  additionalContent,
  wrapperStyle,
  iconStyle,
  contentStyle,
  btnWrapperStyle,
  ...props
}: FeatureBlockProps) => {
  const addAllClasses = ['feature__block'];
  if (iconPosition) addAllClasses.push(`icon_${iconPosition}`);
  if (className) addAllClasses.push(className);

  const Icon = icon && (
    <IconWrapper className="icon__wrapper" {...iconStyle}>
      {icon}
    </IconWrapper>
  );

  return (
    <FeatureBlockWrapper
      className={addAllClasses.join(' ')}
      {...wrapperStyle}
      {...props}
    >
      {Icon}
      {title || description || listItems || button ? (
        <Fragment>
          <ContentWrapper className="content__wrapper" {...contentStyle}>
            {title}
            {description}
            {button && (
              <ButtonWrapper className="button__wrapper" {...btnWrapperStyle}>
                {button}
              </ButtonWrapper>
            )}
            {listItems}
          </ContentWrapper>
          {additionalContent}
        </Fragment>
      ) : (
        ''
      )}
    </FeatureBlockWrapper>
  );
};

export default FeatureBlock;
